// local notification (toast msg)
export const POST_LOCAL_NOTIFICATION = 'POST_LOCAL_NOTIFICATION'
export const REMOVE_LOCAL_NOTIFICATION = 'REMOVE_LOCAL_NOTIFICATION'
